module.exports = __webpack_public_path__ + "img/personal_last.b3409f85.png";